import React from 'react';

const REGISTRY = {
  tacos24:         React.lazy(() => import('./sites/TACOS24/SiteApp')),
  luthieros:       React.lazy(() => import('./sites/LuthierOS/SiteApp')),
  axispme:         React.lazy(() => import('./sites/AXISPME/SiteApp')),
  vibee:           React.lazy(() => import('./sites/VIBEE/SiteApp')),
  quebecstream:    React.lazy(() => import('./sites/QUEBECSTREAM/SiteApp')),
  'aura-geometry': React.lazy(() => import('./sites/AURA_GEOMETRY/SiteApp')),
};

export default REGISTRY;
